import { SAVE_MENU, UPDATE_IS_MOBILE } from './action';
import { MENUS, MenuItemVo } from '../config/menus';

export interface SecondMenuItemVo {
    englishName?: string;
    menuId: string;
    menuName: string
}

interface StateProps {
    menus: MenuItemVo[]; // 导航菜单
    isMobile: boolean; // 是否移动设备, 当物理分辨率为1024及以下时为移动设备
}



const initstate: StateProps = {
    menus: MENUS,
    isMobile: false,
}

/**
 * reducer
 * @param {ILoginState} state
 * @param action
 * @returns {any}
 */
export const reducer = (state: StateProps = initstate, action: any) => {
    switch (action.type) {
        
        // 保存菜单
        case SAVE_MENU:
            return { ...state, menus: action.payload };

        // 保存是否为移动设备
        case UPDATE_IS_MOBILE:
            return { ...state, isMobile: action.payload };    

        default:
            return state;
    }
}
